import axios from "axios";
import { baseUrl } from "../util";
import i18n from "../../i18n";

export const getProductDropdownLCA = ({ setDropdownData, language = null }) => {
  const params = {
    region: "DK",
  };

  // Use provided language or fallback to current i18n language
  const targetLanguage = language || i18n.language;

  // Add language parameter for all languages (including Danish)
  if (targetLanguage) {
    params.language = targetLanguage;
  }

  var config = {
    method: "get",
    url: baseUrl + "/api/business/bonsai-activity-names-with-units",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params,
  };

  axios(config)
    .then(function (response) {
      const uniqueDescriptions = new Set(); // To track unique descriptions

      // Handle the new API response structure with data array
      const dataToFilter = response.data?.data || [];

      const filteredResults = dataToFilter.filter((item) => {
        // Check if the description is already in the Set
        if (!uniqueDescriptions.has(item.name)) {
          uniqueDescriptions.add(item.name); // Add to the Set if it's not already present
          const originalName = item.name; // Store original name for clean value

          // Use the value field from backend if available, otherwise create it
          if (item.value) {
            // Backend already provides the formatted value
            item.name = item.value;
          } else if (item.unit) {
            // Fallback: create display name with unit
            item.name = `${originalName} (${item.unit})`;
            item.value = `${originalName} (${item.unit})`;
          } else {
            item.value = originalName;
          }

          return true; // Keep this item in the filtered results
        }
        return false; // Filter out duplicates
      });

      setDropdownData(filteredResults);
    })
    .catch(function (error) {
      console.log("Error fetching Bonsai data:", error);
      setDropdownData([]); // Set empty array in case of error
    });
};
